/**
 * Labstep
 *
 * @module containers/TransferOwnership
 * @desc Transfer Ownership container
 */

import type {
  APICallOptions,
  APICallStatus,
} from 'labstep-web/models';
import type { Action } from 'labstep-web/models/action.model';
import {
  transferOwnershipAction,
  transferOwnershipActionType,
} from 'labstep-web/state/actions/transfer-ownership';
import { selectApiStatus } from 'labstep-web/state/selectors/ui';
import type { LabstepReduxState } from 'labstep-web/state/types';
import { connect } from 'react-redux';

export type ChildrenProps = {
  transferOwnership: (
    entityName: string,
    entityId:
      | string
      | string[]
      | number
      | number[]
      | (number | string)[],
    groupId: number,
    folderId: string | null | undefined,
    options: APICallOptions,
  ) => void;
  status: APICallStatus;
};

const Container = ({
  children,
  transferOwnership,
  status,
}: {
  children: (props: ChildrenProps) => JSX.Element;
  transferOwnership: ChildrenProps['transferOwnership'];
  status: ChildrenProps['status'];
}) => children({ transferOwnership, status });

const mapStateToProps = (
  state: LabstepReduxState,
): Pick<ChildrenProps, 'status'> => ({
  status: selectApiStatus(state, transferOwnershipActionType),
});

const mapDispatchToProps = (
  dispatch: (action: Action) => void,
): Pick<ChildrenProps, 'transferOwnership'> => ({
  transferOwnership(
    entityName,
    entityId,
    groupId,
    folderId,
    options,
  ) {
    dispatch(
      transferOwnershipAction(
        entityName,
        entityId,
        groupId,
        folderId,
        options,
      ),
    );
  },
});

export const TransferOwnershipContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Container);
